<template>
	<ul class="results-list results-list--logos">
		<!--DEV NOTE: Props used for testing purposes only.  If changed, make sure no extra mark up surrounds elements -->
		<!--CARD START-->
		<li class="results-list__item">
			<LogoCard logoTitle="Report"> </LogoCard>
		</li>
		<!--CARD END-->
		<li class="results-list__item">
			<LogoCard
				logoTitle="Report"
				logoImgSrc="https://images.unsplash.com/photo-1544612318-bcab56ed6311?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
				logoImgAlt="Report Logo"
			>
			</LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard
				logoTitle="Repair Order"
				logoImgSrc="https://previews.123rf.com/images/mayatnik/mayatnik1810/mayatnik181000015/109648118-vertical-iimage-of-glasses-set-with-different-colorful-natural-hot-tea-decorated-with-autumn-leaves-.jpg"
				logoImgAlt="Repair Order Logo"
			>
			</LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="Work Order"> </LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="Quick Lube"> </LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard
				logoTitle="Body Shop"
				logoImgSrc="https://www.qsl.net/g4aon/images/vertical.jpg"
				logoImgAlt="Body Shop Logo"
			>
			</LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="Parts"> </LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="AR"> </LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="PO"> </LogoCard>
		</li>
		<li class="results-list__item">
			<LogoCard logoTitle="Receipts"> </LogoCard>
		</li>
	</ul>

	<!---------- DEV NOTES -----------------
	-- IMAGES:
    -- Current images are for testing only.
    -- If no logo is uploaded, use no-image.svg. Alt text will be "No Logo Uploaded"
    -- Alt text for cards with a logo uploaded will be the " "card title" Logo " 
	-->
</template>

<script>
import LogoCard from './logo-card';

export default {
	name: 'LogosList',
	components: {
		LogoCard
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Logo Manager Screen List
    * Card Layout specific to the Logo Manager
    * Can use SCSS variables = TRUE
    *
    * [Table of Contents]
    *
    * LOGO LIST CARD LAYOUT
 */

/*------------------------------------*\
  #LOGO LIST CARD LAYOUT
\*------------------------------------*/
@import '@/scss/5-objects/_results.scss';

.results-list--logos {
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 35px;

	@include mq($from: md) {
		grid-template-columns: repeat(3, 1fr);
	}

	@include mq($from: lg) {
		grid-template-columns: repeat(5, 1fr);
	}
}
</style>
